import { useEffect, useState } from "react";
import { getTopCitiesSignupCount } from "../../../services/dashboardService";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const TopCities = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      setIsLoading(true);

      const { result } = await getTopCitiesSignupCount();

      if (mounted) {
        const items = result.map((item) => {
          item["Count"] = item.total_count;
          return item;
        });

        setData(items);
        setIsLoading(false);
      }
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="card p-0">
      <div className="p-6">
        <p className="text-gray-500">
          Account Signups <span className="text-gray-400">— Top 5 Cities</span>
        </p>
      </div>
      {isLoading && (
        <div className="flex justify-center items-center space-x-1 h-96">
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
        </div>
      )}
      {!isLoading && (
        <ResponsiveContainer width="100%" height={363}>
          <BarChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 5,
              right: 40,
              left: 20,
              bottom: 20,
            }}
          >
            <Tooltip cursor={{ fill: "#f0f0f0" }} />
            <CartesianGrid strokeDasharray="3 3" />
            <Bar
              fillOpacity={0.5}
              dataKey="Count"
              stroke="#60a5fa"
              strokeWidth={1.5}
              fill="#60a5fa"
            />
            <XAxis
              dataKey="city"
              strokeWidth={0.6}
              axisLine={false}
              tickMargin={10}
              tickLine={false}
              tickSize={5}
              tick={{ fill: "#9ca3af", fontSize: "0.875rem" }}
            />
            <YAxis
              dataKey="Count"
              axisLine={false}
              allowDecimals={false}
              tickMargin={15}
              tickLine={false}
              tickSize={5}
              tick={{ fill: "#9ca3af", fontSize: "0.875rem" }}
            />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default TopCities;
